import { ReactNode } from "react";
import type { Transition } from "framer-motion";
import QuizStep from "@/icons/products/oestra/pcos/products/server.svg";
import ReceiveTreatmentStep from "@/icons/products/oestra/pcos/products/gift.svg";
import StartTreatmentStep from "@/icons/products/oestra/pcos/products/bottle.svg";
import CleanIcon from "@/icons/products/oestra/pcos/result/cleane.svg";
import EnergyIcon from "@/icons/products/oestra/pcos/result/energy.svg";
import NoWaterIcon from "@/icons/products/oestra/pcos/result/no-watter.svg";
import ShotsIcon from "@/icons/products/oestra/pcos/result/shots.svg";
import WeightIcon from "@/icons/products/oestra/pcos/result/weight.svg";
import { StepItem } from "~/sections/HowItWorksSection";
import LabReviewCard from "~/componentsDS/LPComponents/components/LabReviewCard";
import MessagingCard from "~/componentsDS/LPComponents/components/MessagingCard";
import MonitoringCard from "~/componentsDS/LPComponents/components/MonitoringCard";
import type { PropsConsItem } from "./components/PcosBubbleSlide";
import Heading from "~/componentsDS/Typography/Heading";

export const HERO_IMAGES = {
    desktopLarge: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779781827/new_design/Hero_Image_V3_3_k9iptd.webp", 
    desktop: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779782366/new_design/Hero_Image_V3_4_agcrad.webp", 
    tablet: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779099681/new_design/Hero_Image_V3_1_skmcur.webp", 
    mobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779445642/new_design/Hero_7_ar5thm.webp", 
} as const;

export const PcosBubbleSliderData = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779111086/new_design/Rectangle_34624292_1_o4pmbs.webp",
        title: ["Your hormones","shifted first"],
        analyticsTitle: "Your hormones shifted first",
        mobImageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779116098/new_design/Rectangle_5_8_hhhlqi.webp",
        videoUrl: "https://res.cloudinary.com/dirscuuhp/video/upload/v1779787025/new_design/Evergreen_Kling_First_Last_Frame_2026-05-04_07-44-20_3_1_kk9tpp.mp4"
    },
    {
        videoUrl: "https://res.cloudinary.com/dirscuuhp/video/upload/v1779786888/new_design/Evergreen_Kling_First_Last_Frame_2026-05-04_08-14-57_1_1_dut52r.mp4",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779111213/new_design/Rectangle_34624291_3_cayixz.webp",
        title: ["Your body started producing"," more testosterone"],
        analyticsTitle: "Your body started producing more testosterone"
    },
    {
        videoUrl:"https://res.cloudinary.com/dirscuuhp/video/upload/v1781520995/new_design/Third_PCOS_jc5zkc.mp4",
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779111273/new_design/Rectangle_34624290_1_ivqaux.webp",
        title: ["That’s what made weight loss", "nearly impossible"],
        analyticsTitle: "That’s what made weight loss nearly impossible",
    },
];

export const restorePoints = [
    "Periods returning or becoming more regular",
    "Less bloating and water retention",
    "Skin clearing",
    "Hair shedding slowing down",
    "Energy improving",
    "Weight becoming more responsive"
];

export const PcosProps:PropsConsItem[] = [
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779283433/new_design/Frame_2087329686_9_ioy9ih.webp",
        text: "Suppress your hormones (birth control)"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779278090/new_design/Frame_2087329686_2_wvpseg.webp",
        text: "Mask symptoms, not cycles"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779279325/new_design/Frame_2087329686_3_hr53zp.webp",
        text: "Treat symptoms individually"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779279813/new_design/Frame_2087329686_4_wvpvzi.webp",
        text: "Don’t address root cause"
    },
]

export const PcosConsList:PropsConsItem[] = [
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779279860/new_design/Frame_2087329686_5_klkiom.webp",
        text: "Restore progesterone and estradiol"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779279933/new_design/Frame_2087329686_6_yyxpkx.webp",
        text: "Rebalance hormone signaling"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779280397/new_design/Frame_2087329686_7_zxa4dn.webp",
        text: "Lower testosterone naturally"
    },
    {
        iconUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779280455/new_design/Frame_2087329686_8_v76mjj.webp",
        text: "Support your body in restarting its cycle"
    }
]

type BarHeight = {
    readonly outer: number;
    readonly inner: number;
};

export const easeAnimetion = [0.22, 1, 0.36, 1] satisfies Transition["ease"];
export const leftBars = [
    { outer: 100, inner: 85 },
    { outer: 91, inner: 86 },
    { outer: 84, inner: 75 },
    { outer: 75, inner: 93 },
    { outer: 68, inner: 66 },
    { outer: 84, inner: 42 },
    { outer: 84, inner: 54 },
    { outer: 68, inner: 37 },
    { outer: 60, inner: 50 },
    { outer: 84, inner: 42 },
    { outer: 51, inner: 27 },
    { outer: 60, inner: 50 },
    { outer: 45, inner: 73 },
] satisfies readonly BarHeight[];

export const rightBars = [
    { outer: 35, inner: 63 },
    { outer: 40, inner: 62 },
    { outer: 52, inner: 69 },
    { outer: 70, inner: 74 },
    { outer: 70, inner: 81 },
    { outer: 76, inner: 83 },
    { outer: 70, inner: 90 },
    { outer: 70, inner: 90 },
    { outer: 66, inner: 95 },
    { outer: 76, inner: 75 },
    { outer: 80, inner: 85 },
    { outer: 92, inner: 57 },
    { outer: 100, inner: 68 },
] satisfies readonly BarHeight[];

type ResultItem = {
    iconElement: ReactNode;
    text: string;
};

export const restoreHormonePoints = [
    "progesterone",
    "estradiol",
] as const;

export const hormoneBenefitPoints = [
    "lower LH",
    "lower testosterone",
    "help your cycle return",
] as const;

export const resultList:ResultItem[] = [
    {
        iconElement: <NoWaterIcon className="size-12" />,
        text: "Missed or irregular periods"
    },
    {
        iconElement: <WeightIcon className="size-12" />,
        text: "Weight gain"
    },
    {
        iconElement: <ShotsIcon className="size-12" />,
        text: "Acne"
    },
    {
        iconElement: <CleanIcon className="size-12" />,
        text: "Hair thinning or facial hair"
    },
    {
        iconElement: <EnergyIcon className="size-12" />,
        text: "Fatigue and anxiety"
    },
]

export const notAloneData = [
    {
        id: "messaging",
        component: <MessagingCard imageUrl="https://res.cloudinary.com/dirscuuhp/image/upload/v1779347971/new_design/9bfb3e690224077659970839a19aa4bc32c0e906_1_kv2rgb.webp" alt="Unlimited secure messaging with Inner Balance clinician for ongoing hormone support" />,
        title: "Unlimited secured messaging"
    },
    {
        id: "lab-review",
        component: <LabReviewCard alt="Your personalized hormone action plan icon — Inner Balance Oestra treatment steps" />,
        title:"Lab review and dose adjustments if needed"
    },
    {
        id: "monitoring",
        component: <MonitoringCard imageUrl="https://res.cloudinary.com/dirscuuhp/image/upload/v1779347560/new_design/Frame_2087329084_3_jlh70p.webp" alt="Ongoing hormone monitoring with Inner Balance clinician" />,
        title: "Ongoing monitoring — not one-time prescribing."
    },
]

export const hiwData: StepItem[] = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1781599121/new_design/Frame_1171278096_8_stepfirst_ieds2u.webp",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Quiz Intake",
        description: "You share your symptoms, history and goals.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779461093/new_design/Frame_1171278096_11_kiojpd.webp",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Clinical approval for treatment delivery",
        description: "A licensed clinician evaluates and determines next steps. Once approved, prescription is delivered.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1781598807/new_design/Frame_1171278096_10_hmciycyc.webp",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[150px] md:h-[150px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our clinical care team is always here for you whenever you want to check in.",
    },
];

export { DEFAULT_HERO_FEATURES as heroFeaturesData } from "~/componentsDS/LPComponents/data";

export const scienceCardsHeaderElem = <Heading as="h2" size="sm" sizes={{ md: "md" }} className="font-suisseBP max-md:max-w-[345px]">How Oestra<sup>®</sup> supports your <span className="font-featureDisplay font-normal italic text-[28px] md:text-[36px]">hormones</span></Heading>